<section class="white-block shadow-block mb-4 ib-preview-extra">
  <h3><strong>Unclassified Images</strong></h3>
  <p class="ib-preview-empty">
    These images are not published on the website until they are classified.
  </p>
  <nz-image-group>
    <div class="masonry-grid ib-preview-gallery-grid">
      @for (img of images; track img) {
        <div class="grid-item">
          <div>
            <img nz-image [nzSrc]="img" [src]="img" alt="Unclassified image" />
          </div>
        </div>
      }
    </div>
  </nz-image-group>
</section>
